import { Fragment } from "react";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useIntersectionObsever, useLang } from "hooks";
import { ErrorModal, CustomModal } from "components";
import StoreItem from "components/StoreItem";
import { TranslationText } from "components/TextTranslationContainer";

//TODO: remove ltr dir & isArabic check from the component, if arabic content support is added for a store from backend in future

const StoreCategoryWithMenu = ({
  menu,
  menuType,
  onItemClick,
  open,
  setOpen,
  page,
  containerStyleProps = {},
  sectionHeaderContainerProps = {},
  titleStyleProps = {},
  listStyleProps = {},
  listItemStyleProps = {},
  showCartIcon,
  type,
}) => {
  const { newRef } = useIntersectionObsever(menu, menuType);

  const { isArabic } = useLang();

  if (menu?.length <= 0)
    return (
      <div className="h-full flex justify-center items-center">
        <TranslationText text="Store is either closed or not have and active menu" />
      </div>
    );

  return (
    <Fragment>
      {menu?.map(({ categoryId, items }, key) => (
        <div key={key} {...containerStyleProps}>
          <div {...sectionHeaderContainerProps} dir={"ltr"}>
            <h3
              className={`text-20x font-bold px-4 pt-6 text-dark-blue-900 scroll-checker 
              ${isArabic ? "text-right" : "text-left"} ${
                titleStyleProps?.className ?? ""
              }`}
              id={categoryId?._id}
              ref={newRef()}
              style={titleStyleProps?.style ?? {}}
            >
              {categoryId?.baseLanguage?.name}
            </h3>
            {categoryId?.description && (
              <p
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-word",
                }}
                className="text-gray-500 text-13x font-normal px-4 pt-1 "
              >
                {categoryId?.description}
              </p>
            )}
          </div>

          <ul
            className={`flex flex-row flex-wrap justify-between items-start border-b-8 border-gray-100 ${
              listStyleProps?.className ?? ""
            }`}
            style={listStyleProps?.style ?? {}}
          >
            {items?.map((item, itemKey) => (
              <li
                key={itemKey}
                onClick={() => {
                  sessionStorage.setItem(
                    "scroll-positon",
                    window?.scrollY || window?.pageYOffset
                  );
                }}
                className={`flex-100 relative flex-shrink-0 flex gap-2 rounded-sm flex-row justify-between items-center self-stretch bg-white p-4 border-b hover:bg-gray-50 ${
                  listItemStyleProps?.className ?? ""
                }`}
                style={listItemStyleProps?.style ?? {}}
              >
                <StoreItem
                  showItem={onItemClick}
                  {...{ item, open, setOpen, type }}
                  categoryId={categoryId}
                  page={page}
                  showCartIcon={showCartIcon}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}

      <CustomModal
        open={open}
        setOpen={setOpen}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
      >
        <ErrorModal setOpen={setOpen} message={t("store is closed")} />
      </CustomModal>
    </Fragment>
  );
};

const stylePropShape = PropTypes.shape({
  className: PropTypes.string,
  style: PropTypes.object,
});

const categoryIdShape = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  baseLanguage: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
});

StoreCategoryWithMenu.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: categoryIdShape,
      items: PropTypes.arrayOf(PropTypes.object).isRequired,
    })
  ),

  menuType: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  page: PropTypes.string,

  containerStyleProps: PropTypes.object,
  sectionHeaderContainerProps: PropTypes.object,
  titleStyleProps: stylePropShape,
  listStyleProps: stylePropShape,
  listItemStyleProps: stylePropShape,
};

StoreCategoryWithMenu.defaultProps = {
  containerStyleProps: {},
  sectionHeaderContainerProps: {},
  titleStyleProps: {},
  listStyleProps: {},
  listItemStyleProps: {},
};

export default StoreCategoryWithMenu;
